<template>
	<div class="page">
		<div class="main">
			<h1>英文在职证明自动生成器</h1>
			<el-form :model="Form" ref="Form" label-width="140px" style="margin-top: 3.25rem;" class="demo-ruleForm" label-position>
				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label-width="" label="姓名：" prop="name">
							<el-input v-model="Form.name" style="width: 23.125rem;display: block;" placeholder="例如：张三"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">

						<el-form-item label="性别：" prop="gender">
							<el-radio-group v-model="Form.gender">
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="出行时间：" prop="outDate">
							<el-date-picker v-model="Form.outDate" type="date" placeholder="选择日期"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="返程时间：" prop="backDate">
							<el-date-picker v-model="Form.backDate" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="前往国家：" prop="country">
							<el-input v-model="Form.country" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="目的：" prop="objective">
							<el-radio-group v-model="Form.objective">
								<el-radio label="1">旅游</el-radio>
								<el-radio label="2">商务</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="护照号：" prop="passport" >
							<el-input v-model="Form.passport" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="职位：" prop="position">
							<el-input v-model="Form.position" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="入职日期：" prop="joinDate">
							<el-date-picker v-model="Form.joinDate" type="date" placeholder="选择日期"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="月薪(人民币)：" prop="salary">
							<el-input v-model="Form.salary" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="公司名称：" prop="unitName">
							<el-input v-model="Form.unitName" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="公司地址：" prop="unitAddress">
							<el-input v-model="Form.unitAddress" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="公司邮箱：" prop="email">
							<el-input v-model="Form.email" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="公司电话：" prop="unitPhone">
							<el-input v-model="Form.unitPhone" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="负责人姓名：" prop="responsibleName">
							<el-input v-model="Form.responsibleName" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人职位：" prop="responsiblePosition">
							<el-input v-model="Form.responsiblePosition" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="60">
					<el-col :span="12">
						<el-form-item label="邀请方：" prop="invitationName" v-if="Form.objective=='2'">
							<el-input v-model="Form.invitationName" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="支付方式：" prop="paytype" v-if="Form.objective=='2'">
							<el-radio-group v-model="Form.paytype">
								<el-radio label="1">本人</el-radio>
								<el-radio label="2">本单位</el-radio>
								<el-radio label="3">其他单位</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>


				<el-row :gutter="60">
					<el-col :span="12">

						<el-form-item label="支付方：" prop="payName" v-if="Form.paytype=='3' && Form.objective=='2'">
							<el-input v-model="Form.payName" style="width: 23.125rem;" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否需要打印抬头：" prop="isPoint">
							<el-radio-group v-model="Form.isPoint">
								<el-radio label="1">需要</el-radio>
								<el-radio label="2">不需要</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				
				<div class="btn_box">
					<el-button @click="MakeCertificate" type="primary">开始制作</el-button>
					<el-button :disabled="canDown" @click="FileDownload" id="btn_download" type="primary">立即下载</el-button>
				</div>

			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				canDown: true,
				url: '',
				Form: {
					name: '', //姓名
					gender: '', //性别
					outDate: '', //出行时间
					backDate: '', //返程时间
					country: '', //前往国家
					objective: '1', //目的
					passport: '', //护照号
					position: '', // 职位
					joinDate: '', // 入职日期
					salary: '', //月薪(人民币)								
					unitName: '', //公司名称
					unitAddress: '', //公司地址
					email: '', //公司邮箱
					unitPhone: '', //公司电话
					responsibleName: '', //负责人姓名
					responsiblePosition: '', //负责人职位												
					isPoint: '2', //是否需要打印抬头
					invitationName: '', // 邀请方
					paytype: '1', // 支付方式
					payName: '', // 支付方
					// leadCompanyAddress: '',//负责人公司地址
				}
			}
		},

		created() {

		},

		methods: {
			MakeCertificate() {
				this.$api.MakeCertificate(this.Form).then(res => {
					if (res.data.result) {
						this.canDown = false
						this.url = res.data.data
						this.$message.success('制作完成，请点此下载。');
						console.log(res)
					} else {
						this.$message.error("制作失败")
					}
				})
			},
			FileDownload() {
				//a标签跳转下载
				let a = document.createElement('a');
				a.href = this.url;
				a.style.display = 'none';
				//跳转新页面
				a.target = '_blank';
				a.click();
			}
		}
	}
</script>

<style lang='less' scoped>
	div {
		text-align: left;
	}

	.page {
		width: 100%;
		height: 65.25rem;
		position: relative;
		
		/deep/ .el-button{
			margin: 0 auto;
		}
		
		/deep/ .el-row {
			margin-left: 1.25rem !important;
		}

		/deep/ .el-form-item__label {
			white-space: nowrap;
		}

		.main {
			width: 72.5rem;
			height: 58rem;
			background-color: #FFF;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 1.25rem;
			h1 {
				text-align: center;
			}
			.btn_box{
				width: 15.5rem;
				margin: 0 auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/generate/generate.vue